/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
// import { Redirect } from 'react-router-dom'
import Logo from "./../../../assets/Jobvious_logo.png";
import { SignIn } from "aws-amplify-react";
import { Auth } from "aws-amplify";
import { HTTPService } from "../../../services/httpService";
import ScopeService from "../../../services/scopeService";
import { isDealerFinance } from "../../../util/permissions";

const API = new HTTPService();

// Pick the default landing route for an activated scope.
// Dealer-group access (server: user_companies.location_id = 0) lands finance
// users on /financials. Sub-scoped dealer users skip this branch.
function landingRouteFor(scope, role) {
  if (!scope) return "/requestimates";
  const isDealerGroup = scope.type === "dealer" && ScopeService.isDealerGroupUser();
  if (isDealerGroup && isDealerFinance(role)) {
    return "/financials";
  }
  return "/requestimates";
}

export class Login extends SignIn {
  constructor(props) {
    super(props);
    this._validAuthStates = ["signIn", "signOut"];
  }

  processLogin() {
    const username = this.getUsernameFromInput() || '';
    const password = this.inputs.password;

    Auth.signIn(username, password).then((cognitoUser) => {
      // Auth challenges
      if (cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.changeState('requireNewPassword', cognitoUser);
        return;
      }
      if (cognitoUser.challengeName === 'SMS_MFA' || cognitoUser.challengeName === 'SOFTWARE_TOKEN_MFA') {
        this.changeState('confirmSignIn', cognitoUser);
        return;
      }
      if (cognitoUser.challengeName === 'MFA_SETUP') {
        this.changeState('TOTPSetup', cognitoUser);
        return;
      }

      if (!cognitoUser) {
        console.error("No authenticated user found after login");
        alert("Authentication failed. Please try again.");
        return;
      }

      this.completeLogin(cognitoUser).catch((err) => {
        console.error("Login flow error:", err);
        alert("Error completing sign-in. Please try again.");
      });
    }).catch((signInErr) => {
      console.error("SignIn failed:", signInErr);
      if (signInErr.code === 'UserNotConfirmedException') {
        this.changeState('confirmSignUp', { username: this.getUsernameFromInput() });
      } else if (signInErr.code === 'PasswordResetRequiredException') {
        this.changeState('forgotPassword', { username: this.getUsernameFromInput() });
      } else {
        alert("Sign in failed. Please check your credentials and try again.");
      }
    });
  }

  async completeLogin(cognitoUser) {
    // 1) User record
    const userResponse = await API.get(`/auth/login/?email=${cognitoUser.attributes.email}`);
    const user = userResponse.data;
    localStorage.setItem("userAPI", JSON.stringify(user));

    // 2) Full scope tree from the unified endpoint
    const tree = await ScopeService.loadScopeTree(user.User_id);
    if (!tree.scopes.length) {
      alert("Your account has no company assignments. Please contact support.");
      return;
    }

    // 3) Activate the default scope (writes companyAPI / dealerGroupAPI as derived back-compat views)
    const activeScope = await ScopeService.activateScopeByIndex(tree.defaultScopeIndex);

    // 4) named_user_id slug for legacy storage keys
    const slug = (activeScope.name || '').replace(/ /g, '_').toLowerCase();
    localStorage.setItem("named_user_id", JSON.stringify(slug));

    // 5) Stripe capabilities — only for installer-side scopes
    if (activeScope.type === 'installer') {
      try {
        const stripeRes = await API.get(`/api/installers/${activeScope.id}/stripe-status`);
        localStorage.setItem("stripeCapabilities", JSON.stringify(stripeRes.data || {}));
      } catch {
        localStorage.setItem("stripeCapabilities", JSON.stringify({}));
      }
    } else {
      localStorage.setItem("stripeCapabilities", JSON.stringify({}));
    }

    // 6) Redirect
    window.location = landingRouteFor(activeScope, user.role);
  }

  signIn() {
    localStorage.clear();
    this.processLogin();
  }

  showComponent(theme) {
    return (
      <div className="App">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="content p-5">
                <div className="row justify-content-md-center">
                  <div className="card col-lg-4 p5-lg">
                    <div className="card-body">
                      <h5 className="card-title text-center mb-5">
                        <img src={Logo} alt="" />
                      </h5>
                      <h6 className="card-subtitle mb-2 text-muted text-center">
                        Sign in to Jobvious
                      </h6>
                      {/* Form */}
                      <form>
                        <div className="form-group">
                          <label className="font-bold" htmlFor="username">
                            Email
                          </label>
                          <input
                            className="form-control"
                            id="username"
                            key="username"
                            name="username"
                            onChange={this.handleInputChange}
                            type="text"
                          />
                        </div>
                        <div className="form-group">
                          <label className="font-bold" htmlFor="password">
                            Password
                          </label>
                          <input
                            className="form-control"
                            id="password"
                            key="password"
                            name="password"
                            onChange={this.handleInputChange}
                            type="password"
                            autoComplete="off"
                          />
                          <small className="form-text text-muted mt-2">
                            Forgot your password?{" "}
                            <a
                              href="#"
                              onClick={() =>
                                super.changeState("forgotPassword")
                              }
                              style={{ textDecoration: "underline" }}
                            >
                              Reset Password
                            </a>
                          </small>
                        </div>
                        <div className="form-group">
                          <button
                            className="btn btn-outline-primary btn-block mb-3"
                            type="button"
                            onClick={() => this.signIn()}
                          >
                            Lets Go
                          </button>
                        </div>
                      </form>
                      {/* End Form */}
                      {/* Divider */}
                      <hr />

                      {/* New to Jobvious */}
                      <div className="text-center mt-4">
                        <h6>New to Jobvious?</h6>
                        <p>Not sure if you have a login yet?</p>
                        <a
                          className="btn btn-outline-secondary"
                          href="https://www.jobvious.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Visit our Homepage
                        </a>
                      </div>

                      {/* Need help logging in */}
                      <div className="text-center mt-3">
                        <p>
                          Need help logging in?{" "}
                          <a href="mailto:support@jobvious.com?subject=Login%20Assistance&body=Hi%20Jobvious%20Support%2C%0A%0AI%20need%20help%20with%20logging%20in.%20My%20email%20is%3A%20%5Benter%20your%20email%20here%5D.%0A%0AThanks!">
                            Contact Support
                          </a>
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col text-center">
                  <p>&copy; 2026 Jobvious, Inc </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
// export default withRouter(Login);
